var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateItemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Create_Item-Icon",
    d: "M20.25,7.5l-.625,10.632a2.25,2.25,0,0,1-2.247,2.118H6.622a2.25,2.25,0,0,1-2.247-2.118L3.75,7.5M10,11.25h4M3.375,7.5h17.25A1.125,1.125,0,0,0,21.75,6.375v-1.5A1.125,1.125,0,0,0,20.625,3.75H3.375A1.125,1.125,0,0,0,2.25,4.875v1.5A1.125,1.125,0,0,0,3.375,7.5Z",
    transform: "translate(-1.5 -3)",
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateItemIcon);
export default __webpack_public_path__ + "static/media/create_item_icon.08f7d879534472c15eec70fafedf423c.svg";
export { ForwardRef as ReactComponent };